import React from 'react';
import { Link } from 'react-router-dom';
import Footer from '../components/home/Footer';
import { OTHER_APPS } from '../data/otherApps';
import { AppIcon } from './other/OtherIcons';
import './Other.css';

const Other = () => {
  return (
    <div className="other-page">
      <section className="other-hero">
        <div className="other-container">
          <p className="other-eyebrow">Resources</p>
          <h1 className="other-hero-title">Other</h1>
          <p>
            We help startup companies connect with talented candidates and support candidates
            who are looking for new career opportunities.
          </p>
          <p>
            You can use various applications and tools to support development, implementation,
            and communication tasks.
          </p>
        </div>
      </section>

      <section className="other-section">
        <div className="other-container">
          <h2 className="other-section-title">Applications & tools</h2>
          <p className="other-section-lead">
            Choose an app to open its download page for Windows, macOS, and Linux.
          </p>

          <div className="other-icon-grid">
            {OTHER_APPS.map((app) => (
              <Link
                key={app.id}
                to={`/other/${app.id}`}
                className="other-icon-tile"
                style={{ '--app-accent': app.accent }}
              >
                <span className="other-icon-tile-badge">
                  <AppIcon name={app.icon} className="other-icon-tile-img" />
                </span>
                <span className="other-icon-tile-name">{app.name}</span>
                <span className="other-icon-tile-desc">{app.description}</span>
              </Link>
            ))}
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Other;
